import React, { Children } from 'react';
import { SEO } from '../components/seo/SEO';
import { OrganizationSchema, BreadcrumbSchema } from '../components/seo/Schema';
import { FounderStory } from '../components/sections/FounderStory';
import { CoreBeliefs } from '../components/sections/CoreBeliefs';
import { OurMission } from '../components/sections/OurMission';
import { motion } from 'framer-motion';
export function About() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };
  return <>
      <SEO title="About HIRE | Built by D2D Operators for D2D Growth" description="HIRE was built by door-to-door operators who understand the grind. 4,000+ reps recruited, $130M+ in sales generated, 60+ years combined D2D experience." canonical="/about" ogTitle="About The HIRE Advantage | Built by D2D Operators" ogDescription="Meet the team behind HIRE. Built by door-to-door operators who understand recruiting, retention, and scaling sales teams." keywords="d2d recruiting company, door to door sales recruiting, sales team growth experts, d2d operators" data-id="element-1260" />

      <OrganizationSchema name="The HIRE Advantage" url="https://theHIREadvantage.co" logo="https://cdn.magicpatterns.com/uploads/e9LinNZMFPzuWJoK7HkJ9d/Hire_full_new_logo.png" description="The recruiting, retention, and rookie success engine for high-growth D2D and direct sales companies." sameAs={['https://www.linkedin.com/company/thehireadvantage']} data-id="element-1261" />

      <BreadcrumbSchema items={[{
      name: 'Home',
      url: '/'
    }, {
      name: 'About',
      url: '/about'
    }]} data-id="element-1262" />

      <div className="pt-20" data-id="element-1263">
        {/* Hero */}
        <section className="pt-16 pb-12 md:pt-24 md:pb-16 bg-gradient-to-br from-gray-50 to-white overflow-hidden" data-id="element-1264">
          <div className="container-custom" data-id="element-1265">
            <motion.div className="max-w-4xl mx-auto text-center" variants={containerVariants} initial="hidden" animate="visible" data-id="element-1266">
              <motion.div className="inline-block bg-mint/10 text-mint-dark px-4 py-2 rounded text-sm font-semibold mb-6" variants={itemVariants} data-id="element-1267">
                Our Story
              </motion.div>
              <motion.h1 className="mb-6" variants={itemVariants} data-id="element-1268">
                Built by Operators. Designed for Growth.
              </motion.h1>
              <motion.p className="text-body-large leading-relaxed mb-8" variants={itemVariants} data-id="element-1269">
                HIRE wasn't built by consultants. It was built by door-to-door
                guys. We understand the grind, the rejection, and the pressure
                to grow a team.
              </motion.p>

              {/* Stats Grid */}
              <motion.div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8" variants={itemVariants} data-id="element-1270">
                <div className="text-center" data-id="element-1271">
                  <div className="text-3xl font-bold text-mint mb-1" data-id="element-1272">
                    4,000+
                  </div>
                  <div className="text-sm" data-id="element-1273">Total Reps Recruited</div>
                </div>
                <div className="text-center" data-id="element-1274">
                  <div className="text-3xl font-bold text-mint mb-1" data-id="element-1275">200K+</div>
                  <div className="text-sm" data-id="element-1276">Doors Knocked</div>
                </div>
                <div className="text-center" data-id="element-1277">
                  <div className="text-3xl font-bold text-mint mb-1" data-id="element-1278">
                    $130M+
                  </div>
                  <div className="text-sm" data-id="element-1279">Sales Generated</div>
                </div>
                <div className="text-center" data-id="element-1280">
                  <div className="text-3xl font-bold text-mint mb-1" data-id="element-1281">
                    60+ years
                  </div>
                  <div className="text-sm" data-id="element-1282">Combined Team Experience</div>
                </div>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* Founder Story */}
        <FounderStory data-id="element-1283" />

        {/* Core Beliefs */}
        <CoreBeliefs data-id="element-1284" />

        {/* Our Mission */}
        <OurMission data-id="element-1285" />

        {/* Final CTA */}
        <section className="section-padding bg-gray-50" data-id="element-1286">
          <div className="container-custom" data-id="element-1287">
            <motion.div className="max-w-3xl mx-auto text-center" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.6,
            ease: [0.25, 0.1, 0.25, 1]
          }} data-id="element-1288">
              <h2 className="mb-6" data-id="element-1289">If This Resonates, Let's Talk</h2>
              <p className="text-body-large mb-8 leading-relaxed" data-id="element-1290">
                We work best with leaders who value systems over shortcuts.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1291">
                <a href="/book-call" className="inline-block bg-mint hover:bg-mint-dark text-deep-blue font-bold px-8 py-4 rounded-lg transition-colors shadow-lg" data-id="element-1292">
                  Schedule a Strategy Call →
                </a>
                <a href="/case-studies" className="inline-block border-2 border-deep-blue text-deep-blue hover:bg-deep-blue hover:text-white font-bold px-8 py-4 rounded-lg transition-colors" data-id="element-1293">
                  See Our Results
                </a>
              </div>
            </motion.div>
          </div>
        </section>
      </div>
    </>;
}